// extracted by mini-css-extract-plugin
export default {"root":"styles_root__yg8gd","warning":"styles_warning__E2-tc"};